import { render, staticRenderFns } from "./MiniDonut.vue?vue&type=template&id=bdfef722&scoped=true&"
import script from "./MiniDonut.vue?vue&type=script&lang=js&"
export * from "./MiniDonut.vue?vue&type=script&lang=js&"
import style0 from "./MiniDonut.vue?vue&type=style&index=0&id=bdfef722&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdfef722",
  null
  
)

export default component.exports